export const SHOW_DOWNLOAD_DETAILS = 'SHOW_DOWNLOAD_DETAILS';
export const HIDE_DOWNLOAD_DETAILS = 'HIDE_DOWNLOAD_DETAILS';
